import { ICompany } from 'app/shared/model/company.model';
import { ITruckGroup } from 'app/shared/model/truck-group.model';
import { RiskClassification } from 'app/config/constants';

export type VirtualFenceSyncStatus = 'PENDING_SYNC' | 'SYNCED' | 'PENDING_DELETE' | 'DELETED';

export interface IVirtualFenceCircle {
  id?: number;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  radius?: number | null;
  activated?: boolean | null;
  syncStatus?: VirtualFenceSyncStatus | null;
  riskClassification?: RiskClassification | null;
  notificationEnabled?: boolean | null;
  company?: ICompany | null;
  truckGroups?: ITruckGroup[] | null;
}

export const defaultValue: Readonly<IVirtualFenceCircle> = {
  activated: false,
};
